export const SUPPORT_EMAIL = 'hello@plot.so';
export const TERMS_OF_SERVICE_LINK = 'https://www.plot.so/terms-of-services';
export const PRIVACY_POLICY_LINK = 'https://www.plot.so/privacy-policy';
